/**
 * Single-pass categorization of slides into visible, complete, flagged, incomplete, and visibleIncomplete.
 * Use this when multiple categories are needed for the same slides array.
 */
export function categorizeSlides(slides) {
  const result = {
    visible: [],
    complete: [],
    flagged: [],
    incomplete: [],
    visibleIncomplete: [],
  };

  for (const slide of slides) {
    const visible = slide.state?.visible === true;
    const complete = !!slide.state?.complete;
    const flagged = !!slide.state?.flag;
    const incomplete = slide.state?.complete === false || flagged;

    if (visible) result.visible.push(slide);
    if (complete) result.complete.push(slide);
    if (flagged) result.flagged.push(slide);
    if (incomplete) result.incomplete.push(slide);
    if (visible && incomplete) result.visibleIncomplete.push(slide);
  }

  return result;
}

export const getVisibleSlides = slides => categorizeSlides(slides).visible;

export const getCompleteSlides = slides => categorizeSlides(slides).complete;

export const getFlaggedSlides = slides => categorizeSlides(slides).flagged;

export const getIncompleteSlides = slides =>
  categorizeSlides(slides).incomplete;

export const getSectionSlides = (slides, sectionId) =>
  slides.filter(s => s.sectionId === sectionId);
